import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import ItemMainBlockV1 from '../../../_block_components/item_main_block_v1';
import ItemPriceBlockV1 from '../../../_block_components/item_price_block_v1';
import ItemDescriptionBlockV1 from '../../../_block_components/item_description_block_v1';

const ItemPage = ({ contentData, path_to_folder }) => {
  const currentPublication = useSelector((state) => state.currentPublication.currentPublication);

  React.useEffect(() => {
    if (currentPublication) {
      // console.log('ItemPage currentPublication:', currentPublication);
    }
  }, [currentPublication, contentData, path_to_folder]);

  const renderedBlocks = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData)) {
      return [];
    }
    return contentData.filter((_, index) => index !== 0);
  }, [contentData]);

  if (!contentData || !Array.isArray(contentData)) {
    return null;
  }

  return (
    <div className={styles.itemPage}>
      <div className={styles.contentContainer}>
        <h1 className={styles.itemTitle}>
          {currentPublication?.show_name || currentPublication?.title || 'Элемент'}
        </h1>

        <div className={styles.blocksGrid}>
          {renderedBlocks.map((block, idx) => {
            const normalizedType = ((block?.boock_tag || block?.block_tag) || '').toLowerCase();
            const isHalf = idx === 0 || idx === 1;
            const isLast = idx === renderedBlocks.length - 1;

            const className = [
              styles.gridItem,
              isHalf ? styles.halfWidth : '',
              !isHalf && isLast ? styles.fullWidth : '',
              !isHalf && !isLast ? styles.fullWidth : '',
            ]
              .filter(Boolean)
              .join(' ');

            switch (normalizedType) {
              case 'main_block':
                return (
                  <div key={idx} className={className}>
                    <ItemMainBlockV1 block={block} path_to_folder={path_to_folder} />
                  </div>
                );
              case 'price_block':
                return (
                  <div key={idx} className={className}>
                    <ItemPriceBlockV1 block={block} itemData={currentPublication} />
                  </div>
                );
              case 'description_block':
                return (
                  <div key={idx} className={className}>
                    <ItemDescriptionBlockV1 block={block} />
                  </div>
                );
              default:
                return (
                  <div key={idx} className={`${className} ${styles.contentBlock}`}>
                    <h3>Блок {idx + 1}</h3>
                    <p>
                      <strong>Тип:</strong> {(block?.boock_tag || block?.block_tag) || 'Не указан'}
                    </p>
                    <p>
                      <strong>Содержимое:</strong>
                    </p>
                    <pre>{JSON.stringify(block, null, 2)}</pre>
                  </div>
                );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default ItemPage;
